import { Route, Routes } from "react-router-dom";
import DynamicTitleProvider from "../dynamicTitle/dynamicTitle.provider";
import SetPaymentDetailsSuccessPageComponent from "../../pages/SetPaymentDetailsSuccessPageComponent";
import ChargingTransactionLoginPage from "../../pages/ChargingTransactions/ChargingTransactionLoginPage";
import ChargingTransactionDetailsPage from "../../pages/ChargingTransactions/ChargingTransactionDetailsPage";
import ChargePointDetailsPageComponent from "../../pages/ChargePointDetailsPageComponent";
import NotFoundPageComponent from "../../pages/NotFoundPageComponent";
import { useRoute } from "../../hooks/useRoute..hook";
import FloatContactUsButtonComponent from "../../components/contactUs/FloatContactUsButtonComponent";
import ContactUsPageComponent from "../../pages/contactUs/ContactUsPageComponent";

export const RoutesProvider = () => {
  const { companyId } = useRoute();
  return (
    <DynamicTitleProvider companyId={companyId}>
      <Routes>
        {/* Specific routes - must come before generic patterns */}
        <Route path="/setPaymentDetailsSuccess" element={<SetPaymentDetailsSuccessPageComponent />} />
        <Route path="/transactionLogin/chargePoint/:chargePointId" element={<ChargingTransactionLoginPage />} />
        <Route path="/company/:companyId/contactUs" element={<ContactUsPageComponent />} />
        <Route path="/company/:companyId/chargePoint/:chargePointId/chargingTransaction/:transactionToken" element={<ChargingTransactionDetailsPage />} />
        {/* Single route for charge point - handles all query params (clientId, paymentTokenId, step) */}
        <Route path="/company/:companyId/chargePoint/:chargePointId" element={<ChargePointDetailsPageComponent />} />
        {/* OCPI format charge point route - supports external navigation: /{partyId}/{uid}/{connectorNumber} */}
        {/* This route must come after all specific routes but before wildcard (*) to allow external apps to navigate directly */}
        <Route path="/:partyId/:uid/:connectorNumber" element={<ChargePointDetailsPageComponent />} />
        {/* Wildcard route - must be last */}
        <Route path="*" element={<NotFoundPageComponent />} />
      </Routes>
      {/* {companyId && <FloatContactUsButtonComponent companyId={companyId} />} */}
      <FloatContactUsButtonComponent companyId={companyId} />
    </DynamicTitleProvider>
  );
};

export default RoutesProvider;
